module.exports = __webpack_public_path__ + "img/heading_no.89280407.svg";